import React from "react";
import { Fade, Tooltip } from "@mui/material";
import { InfoIcon } from "./ProjectIcons";

type InfoTooltipProps = {
  /** The explanatory text shown on hover/focus. */
  text: string;
  /** Tooltip placement relative to the icon. */
  placement?: "top" | "right" | "bottom" | "left";
};

/**
 * A small hover/focus info icon with a tooltip, following the app's MUI Tooltip
 * + InfoIcon pattern. The trigger is a real (chrome-reset) button so it is a
 * semantic, keyboard-operable control with the text as its accessible label.
 * @param text the tooltip body
 * @param placement where the tooltip appears (default "top")
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  placement = "top",
}) => (
  <Tooltip
    title={text}
    placement={placement}
    arrow
    slotProps={{ tooltip: { sx: { fontSize: "0.95em", maxWidth: 320 } } }}
    TransitionComponent={Fade}
    TransitionProps={{ timeout: 600 }}
  >
    <button
      type="button"
      aria-label={text}
      className="cursor-pointer inline-flex items-center border-0 bg-transparent p-0"
    >
      <InfoIcon />
    </button>
  </Tooltip>
);

export default InfoTooltip;
